<template>
	<div class="tpl finds-wrap">
		<find-header :search-title="searchTitle" :address="nowAddress"></find-header>
		<div id="find-banner-wrap">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="item in banners">
						<div>
							<div class="img-box"><a :href="item.link+'?uid='+uid"><img :src="item.img" /></a></div>
						</div>
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div>
		</div>
		<div id="news-wrap">
			<div class="news-content" v-if="news[nowNewsIndex]">
				<div class="news-img">
					<img :src="news[nowNewsIndex].avatar" alt="" />
				</div>
				<div class="news-text">
					<p>{{news[nowNewsIndex].nickname}}：发布了新的约会信息。</p>
				</div>
			</div>
		</div>
		<!--同城相约-->
		<div id="invitation-wrap">
			<div class="p-header">
				<p class="p-title">同城相约</p>
				<router-link tag="p" :to="{name:'appointment-list'}" class="p-more">更多</router-link>
			</div>
			<div class="invitation-list" v-if="appointments">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="item in appointments">
							<div class="list-item">
								<div class="user-img">
									<img :src="item.avatar" alt="" />
									<div class="user-sex">
										<img v-if="item.gender==1" src="../../assets/img/finds/ic_user_man@2x.png" alt="" />
										<img v-if="item.gender==2" src="../../assets/img/finds/ic_user_woman@2x.png" alt="" />
									</div>
									<div class="user-distence" v-if="item.distance">
										<span>距你{{item.distance}}</span>
									</div>
								</div>
								<div class="item-labels">
									<span>{{item.name}}</span>
									<span v-if="item.consumption_type==0">AA制</span>
									<span v-if="item.consumption_type==1">我买单</span>
									<span v-if="item.consumption_type==2">你买单</span>
								</div>
								<p class="item-btn">
									<button @click="goToAppointmentDetail(item.r_id,item.uid)">应约</button>
								</p>
							</div>
						</div>
					</div>
					<!-- Add Pagination -->
					<div class="swiper-pagination"></div>
				</div>
			</div>
			<div class="no-content" v-else>
				<img src="../../assets/img/default/no-appointment.png"/>
				<p>暂无约会内容，去做第一个邀约的人吧~!</p>
				<p><button>点我发布约会</button></p>
			</div>
		</div>
		<!--脱单活动-->
		<div id="appointment-wrap">
			<div class="p-header">
				<p class="p-title">脱单活动</p>
				<router-link tag="p" :to="{name:'activity-list'}" class="p-more">更多</router-link>
			</div>
			<div class="appointment-list">
				<ul>
					<li class="appointment-list-item" v-for="item in activities" @click="goToActivityDetail(item.aid)">
						<p class="item-title">
							<span class="tag">进行中</span> {{item.title}}
						</p>
						<div class="item-img">
							<img :src="item.attach" />
							<span class="join-num">
								<img src="../../assets/img/finds/ic_list_baoming@2x.png" alt="" />{{item.enrolment}}人
							</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<get-position @getPosition="getPosition"></get-position>
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css';
	import Swiper from 'swiper';
	import FindHeader from "../Common/HeaderSearchAdd"
	import GetPosition from '../Common/GetPosition'

	export default {
		name: "finds",
		components: {
			FindHeader,
			GetPosition
		},
		data() {
			return {
				uid: "",
				searchTitle: "搜索活动名称、活动主题",
				nowAddress: "",
				banners: "", //banner数据
				news: "",
				nowNewsIndex: 0,
				appointments: "",
				activities: ""
			}
		},
		mounted() {
			var _this = this;

			setTimeout(function() {
				var bannerSwiper = new Swiper('#find-banner-wrap .swiper-container', {
					initialSlide: 1,
					slidesPerView: 1.2,
					autoplay: true,
					centeredSlides: true,
					loop: true,
					pagination: {
						el: '#find-banner-wrap .swiper-pagination',
						clickable: true,
					},
				});

				var invitationSwiper = new Swiper('#invitation-wrap .swiper-container', {
					slidesPerView: 2.5,
					freeMode: true,
				})
			}, 800)

		},
		created() {
			var that = this;
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "finds");
			this.$store.commit("changeTabBarShow", true);
			this.nowAddress = this.$route.query.add || this.$store.state.nowAddress ||this.getCookie("yushuiyuanadd")||this.getLocalStorage("yushuiyuanadd"); //获取用户地址
			console.log(this.nowAddress)
			this.getFindInfo();

			//滚动新闻
			setInterval(function() {
				if(that.nowNewsIndex < that.news.length - 1) {
					that.nowNewsIndex++;
				} else {
					that.nowNewsIndex = 0;
				}
			}, 2000)
		},
		methods: {
			getPosition(data) {
				this.$store.commit("setNowAdd", data.name);
				this.nowAddress = this.$route.query.add || this.$store.state.nowAddress; //获取用户地址
				
				console.log(this.nowAddress)
				this.getFindInfo();
			},
			getFindInfo() {
				this.$axios({
					url: "Appointment/find",
					method: "post",
					data: {
						city: this.nowAddress
					},
					timeout: 3000
				}).then(res => {
					console.log(res);
					if(res.data.code == 200) {
						this.banners = res.data.data.banner;
						this.news = res.data.data.news;
						this.appointments = res.data.data.appointment;
						this.activities = res.data.data.activity;
					}
				}).catch(err => {
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message: "加载超时，请重试",
						position: "bottom",
						duration: 3000
					})
				})
			},
			goToAppointmentDetail(id, uid) {
				console.log(this.uid, id, uid);
				if(uid == this.uid) {
					this.$router.push({
						name: "appointment-mine",
						query: {
							id: id
						}
					})
				} else {
					this.$router.push({
						name: "appointment-other",
						query: {
							id: id
						}
					})
				}

			},
			goToActivityDetail(id) {
				this.$router.push({
					name: "activity-detail",
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.finds-wrap {
		background: #fff url(../../assets/img/finds/bg_header_zise@2x.png) no-repeat top center;
		background-size: 100% auto;
		background-position-y: -1rem;
	}
	
	#find-banner-wrap {
		padding-top: 0.5rem;
	}
	
	#find-banner-wrap .swiper-container {
		width: 100%;
		height: 10rem;
		padding-bottom: 2rem;
	}
	
	#find-banner-wrap .swiper-wrapper {
		display: flex;
		align-items: center;
	}
	
	#find-banner-wrap .swiper-slide {
		border-radius: 1rem;
		overflow: hidden;
	}
	
	.swiper-slide {
		text-align: center;
		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}
	
	#find-banner-wrap .swiper-slide>div {
		width: 100%;
		border-radius: 1rem;
		overflow: hidden;
		height: 100%;
		transition: 300ms;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	#find-banner-wrap .swiper-slide .img-box {
		width: 90%;
		height: 90%;
		transition: 300ms;
		border-radius: 1rem;
		overflow: hidden;
	}
	
	#find-banner-wrap .swiper-slide.swiper-slide-active .img-box {
		width: 100%;
		height: 100%;
		transition: 300ms;
	}
	
	#find-banner-wrap .swiper-slide img {
		width: 100%;
		display: block;
	}
	/*#find-banner-wrap .swiper-slide.swiper-slide-active img {
		width: 100%;
		transition: 300ms;
		display: block;
	}*/
	
	#find-banner-wrap>>>.swiper-pagination-bullet {
		width: 1rem;
		height: 0.3rem;
		border-radius: 1rem;
		background: #a5a5a5;
		transition: 300ms;
	}
	
	#find-banner-wrap>>>.swiper-pagination-bullet-active {
		width: 2rem;
		background: #ff6161;
	}
	
	#news-wrap {
		background: url(../../assets/img/finds/bg_img_huaban@2x.png) no-repeat;
		background-size: 100%;
		padding: 0.5rem 0.5rem;
	}
	
	#news-wrap .news-content {
		display: flex;
		background: url(../../assets/img/finds/bg_img_zouma@2x.png) no-repeat 1rem 1.1rem;
		background-size: 88%;
	}
	
	#news-wrap .news-img {
		width: 4.55rem;
		height: 4rem;
		background: url(../../assets/img/finds/bg_user_head@2x.png) no-repeat center center;
		background-size: 100%;
		position: relative;
	}
	
	#news-wrap .news-img img {
		width: 2.65rem;
		height: 2.65rem;
		border-radius: 50%;
		position: absolute;
		left: 0.85rem;
		top: 0.95rem;
	}
	
	#news-wrap .news-text {
		margin-top: 1.55rem;
		font-size: 0.8rem;
		color: rgba(255, 255, 255, .8);
		background: rgba(128, 67, 121, .4);
		width: 60%;
		height: 1.5rem;
		line-height: 1.5rem;
		padding-left: 1rem;
		overflow: hidden;
		border-radius: 2rem;
	}
	
	#news-wrap .news-text>p {
		width: 100%;
		height: 100%;
	}
	
	.p-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem;
	}
	
	.p-title {
		font-size: 1.2rem;
		line-height: 1.6rem;
		font-weight: bold;
		color: #4a4a4a;
		background: url(../../assets/img/finds/ic_list_tab@2x.png) no-repeat left center;
		background-size: contain;
		padding-left: 1.6rem;
	}
	
	.p-more {
		font-size: 0.8rem;
		line-height: 1.6rem;
		font-weight: bold;
		color: #bdbdbd;
		background: url(../../assets/img/finds/ic_list_jinru_default@2x.png) no-repeat right center;
		background-size: contain;
		padding-right: 1.6rem;
	}
	
	#invitation-wrap .swiper-container {
		width: 100%;
	}
	
	#invitation-wrap .swiper-slide {
		padding: 10px;
	}
	
	#invitation-wrap .swiper-slide img {
		width: 100%;
	}
	
	#invitation-wrap .list-item {
		border-radius: 5px;
		overflow: hidden;
		box-shadow: 0 5px 7px rgba(84, 21, 249, .1);
		padding: 0 0 0.5rem;
	}
	
	#invitation-wrap .list-item .user-img {
		max-height: 6rem;
		overflow: hidden;
		position: relative;
	}
	
	#invitation-wrap .list-item .user-img img {
		width: 100%;
		display: block;
	}
	
	#invitation-wrap .list-item .user-img .user-sex {
		position: absolute;
		bottom: 0;
		left: 0;
	}
	
	#invitation-wrap .list-item .user-img .user-sex img {
		width: 1.5rem;
	}
	
	#invitation-wrap .list-item .user-img .user-distence {
		position: absolute;
		bottom: 0.3rem;
		right: 0.3rem;
		background: rgba(78, 5, 255, .3);
		padding: 0 1rem;
		display: block;
		font-size: 0.6rem;
		color: #fff;
		border-radius: 1rem;
		line-height: 1.2rem;
	}
	
	#invitation-wrap .item-labels {
		text-align: left;
		padding: 0.5rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	#invitation-wrap .item-labels span {
		font-size: 0.65rem;
		color: #FFFFFF;
		line-height: 1.2rem;
		height: 1.2rem;
		padding: 0 0.4rem;
		background: rgba(1, 174, 240, .4);
		margin-right: 0.6rem;
		border-radius: 4px;
	}
	
	#invitation-wrap .item-btn button {
		font-size: 0.85rem;
		height: 1.8rem;
		width: 60%;
		border-radius: 2rem;
		border: 0;
		outline: 0;
		color: #fff;
		background: linear-gradient(to right, #7644fa, #9c7cff);
	}
	
	#invitation-wrap .item-btn button:active {
		opacity: .8;
	}
	
	#appointment-wrap .appointment-list {
		padding: 0.5rem;
	}
	
	#appointment-wrap .appointment-list-item {
		border-radius: 0.5rem;
		overflow: hidden;
		box-shadow: 0 0 10px rgba(84, 21, 249, .2);
		margin-bottom: 1rem;
	}
	
	#appointment-wrap .appointment-list-item .item-title {
		padding: 0.8rem 1rem;
		font-size: 1rem;
		font-weight: bold;
		color: #282828;
		line-height: 1.5rem;
	}
	
	#appointment-wrap .appointment-list-item .item-title .tag {
		background: rgba(255, 97, 97, .7);
		color: #fff;
		font-size: 0.6rem;
		padding: 0.2rem 0.5rem;
		border-radius: 0.2rem;
	}
	
	#appointment-wrap .appointment-list-item .item-img {
		position: relative;
		width: 100%;
		max-height: 10rem;
	}
	
	#appointment-wrap .appointment-list-item .item-img>img {
		width: 100%;
		display: block;
	}
	
	#appointment-wrap .appointment-list-item .item-img .join-num {
		position: absolute;
		right: 0.5rem;
		bottom: 0.5rem;
		background: rgba(40, 40, 40, .2);
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.6rem;
		color: #fff;
		padding: 0.2rem 0.8rem;
		border-radius: 1rem;
	}
	
	#appointment-wrap .appointment-list-item .item-img .join-num>img {
		width: 1rem;
		margin-right: 0.3rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/Finds.vue